export class HardwareStatus {  
    constructor(public readonly OnlineCount: number,
                public readonly OfflineCount: number,
                public readonly WarningCount: number,
                public readonly ErrorCount: number,
                public readonly UnknownCount: number) {
    }    
}